import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';

function MuiRTL({ children }) {
	const cache = createCache({
		key: 'muirtl',
		stylisPlugins: [rtlPlugin as any],
	});

	return <CacheProvider value={cache}>{children}</CacheProvider>;
}

export default MuiRTL;
